import { ParsedQuery } from '@/types/parsedQuery.js';
import { useRouter } from 'next/router';

type UsePreviousRoute = {
  lastPath: string | null;
  lastPathname: string | null;
  lastQuery: ParsedQuery | null;
};

const ref: UsePreviousRoute = {
  lastPath: null,
  lastPathname: null,
  lastQuery: null,
};

export const usePreviousRoute = (): UsePreviousRoute => {
  const router = useRouter();
  router.events?.on('routeChangeStart', () => {
    ref.lastPath = router.asPath;
    ref.lastPathname = router.pathname;
    ref.lastQuery = router.query;
  });

  return ref;
};
